import React from 'react';
import { useServingsClasses } from '../hooks/useServingsClasses';

export function withUseServingsClassesHook(Component) {
    return function WrappedComponent(props) {
        const myHookValue = useServingsClasses();
        return <Component {...props} servingsClasses={myHookValue} />;
    }
}